<template>
  <div>
    <div
      id="map-canvas"
      class="page-header page-header-large"
    />


    <!-- Services -->  
     
    <div class="container">        
      <div class="row ">
        <div class="content-center col-md-3">
          <div
            class="image-container img-raised city pophover turngreen"
            style="min-height:220px"
            @click="moveToLocation(MTL . lnglat,MTL . title)"
          >
            <h5 class="mb-2 font-weight-bold text-uppercase">
              MONTREAL
            </h5> 
            <div class="">            
              <span v-html="$t('Contact.headoffice')">Head Office</span><br>    
              2400 Halpern <br>
              Montreal, QC, Canada <br>
              H4S 1S8 <br><br>
              514. 332. 5020
            </div>
          </div>                
        </div>

        <div class="content-center col-md-3">
          <div
            class="image-container img-raised img-radius city pophover turngreen"
            style="min-height:220px"
            @click="moveToLocation(TOR . lnglat,TOR . title)"
          >
            <h5 class="mb-2 font-weight-bold text-uppercase">
              MISSISSAUGA
            </h5>
            <div class="">
              7385 Bren Road, Unit 3 <br>
              Mississauga, ON, Canada <br>
              L4T 1H3 <br><br>
              905. 362. 0821
            </div>
          </div>    
        </div>

        <div class="content-center col-md-3">
          <div
            class="image-container img-raised img-radius city pophover turngreen"
            style="min-height:220px"
            @click="moveToLocation(MC1.lnglat,MC1.title)"
          >
            <h5 class="mb-2 font-weight-bold text-uppercase">
              Montreal MC1
            </h5>
            <div class="">
              2450 Avenue Marie-Curie  <br>
              Montréal, QC, Canada <br>
              H4S 1N1 <br><br>
              514. 332. 5020
            </div>
          </div>    
        </div>

        <div class="content-center col-md-3">
          <div
            class="image-container img-raised img-radius city pophover turngreen"
            style="min-height:220px"
            @click="moveToLocation(MC2.lnglat,MC2.title)"
          >
            <h5 class="mb-2 font-weight-bold text-uppercase">
              Montreal MC2
            </h5>
            <div class="">
              2520 Avenue Marie-Curie  <br>
              Montréal, QC, Canada <br>
              H4S 1N1 <br><br>
              514. 332. 5020
            </div>
          </div>    
        </div>
      </div>          
    </div>
      

    <!-- -->
    <div
      class="bluesection"
      style="margin-top:40px;"
    >
      <h2
        class="title"
        v-html="$t('Contact.Git')"
      >
        Get in touch
      </h2>
    </div>    

    <div class="section">
      <div class="container">
        <div class="col-md-5  ml-auto mr-auto ">
          <form id="contact-form">                
            <div class="row">
              <label v-html="$t('Contact.Name')">Name</label>
              <input
                v-model="Contact.Name"
                aria-describedby="addon-right addon-left"
                class="custom_form"
              >

              <label v-html="$t('Contact.Phone')">Phone Number</label>
              <input
                v-model="Contact.Phone"
                aria-describedby="addon-right addon-left"
                class="custom_form"
              >

              <label v-html="$t('Contact.Email')">Email</label>
              <input
                v-model.trim="$v.Contact.Email.$model"
                aria-describedby="addon-right addon-left"
                class="custom_form"
                :class="{ 'custom_form error': $v.Contact.Email.$error }"
              >

              <label
                :class="{ 'custom_form error': $v.data.DIVISION.$error }"
                v-html="$t('Contact.Recipient')"
              >Select Recipient</label>
              <select
                id="form_need"
                v-model="data.DIVISION"
                v-model.trim="$v.data.DIVISION.$model"
                aria-describedby="addon-right addon-left"
                class="custom_form"
                :class="{ 'custom_form error': $v.data.DIVISION.$error }"
              >
                <option
                  value=""
                  disabled
                  selected
                />                                                                       
                <option
                  value="WAREHOUSE"
                  v-html="$t('Contact.Warehousing')"
                >
                  Warehousing
                </option>
                <option
                  value="TRANSPORT"
                  v-html="$t('Contact.Transportation')"
                >
                  Transportation
                </option>
                <option
                  value="FREIGHT AND BROKRAGE"
                  v-html="$t('Contact.Freightsales')"
                >
                  Freight Brokerage Sales and Consulting
                </option>
                <option
                  value="ACCOUNTING"
                  v-html="$t('Contact.Accounting')"
                >
                  Accounting
                </option>
                <option
                  value="HUMAN RESOURCES"
                  v-html="$t('Contact.HumanRes')"
                >
                  Human Resources
                </option>
                <option
                  value="GENERAL INQUIRY"
                  v-html="$t('Contact.GenInq')"
                >
                  General Inquiry
                </option>
              </select>                
                  
              <label v-html="$t('Contact.Message')">Your Message </label>
              <textarea
                v-model="data.Message"
                v-model.trim="$v.data.Message.$model"
                class="custom_form"
                rows="4"
                required="required"
                data-error="Type Message Here "
                style="height:300px"
                :class="{ 'error': $v.data.Message.$error }"
              />                                
              <small>({{ data.Message.length }} / 50)</small>

              <div style="width:100%;">
                <div
                  class="send-button"
                  style="float:right;"
                >
                  <button
                    type="button"
                    class=" btn-lg hoverblue"
                    @click="sendmessage"
                  >
                    <!---->Send Message<!---->
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { required, email,minLength } from 'vuelidate/lib/validators'

export default {
  validations: {
    Contact: {
      //Name: { required },
      //Phone: { required },        
      //Department: { required },
      Email: { required, email }
    },
    data:{    
      DIVISION: { required },
      Message: { minLength: minLength(50) }
    }
  },  
  data() {
    return {    
      year: new Date().getFullYear(),
      Contact: {
        Name: '',
        Phone: '',
        Email: '',
        Department: ''
      },
      data:{
        DIVISION: '',
        Message: ''
      },
      MTL: {
        lnglat: new google.maps.LatLng(45.487129, -73.751289),
        title: "2400 Halpern Montreal, QC H4S 1S8"
      },
      TOR: {
        lnglat: new google.maps.LatLng(43.705845,-79.661504),
        title: '7385 Bren Road, Unit 3 Mississauga, ON, Canada L4T 1H3'
      },
      MC1: {
        lnglat: new google.maps.LatLng(45.47817083870002, -73.76704949418654),
        title: '2450 Avenue Marie-Curie Montréal Québec H4S 1N1'
      },
      MC2: {
        lnglat: new google.maps.LatLng(45.47991966599586, -73.76850532395386),
        title: '2520 Avenue Marie-Curie Montréal Québec H4S 1N1'
      },      
      mapOptions: {
        zoom: 6,
        streetViewControl: false,
        scrollwheel: false,
        zoomControl: false,
        mapTypeControl: false,
        panControl: false,
        center: new google.maps.LatLng(44.9, -76.71)     
      },      
      styledMap:  new google.maps.StyledMapType(
        [{ stylers: [{ saturation: -100, invert: 1 }] }],
        {name: "Styled Map"}
      ),      
      map : null      
    };
  },
  mounted: function (){
    this.map = new google.maps.Map(document.getElementById('map-canvas'), this.mapOptions);

    let vm = this  
    this.$nextTick().then(() => {      
      // Code that will run only after the
      // entire view has been rendered
      vm.initGmap()
    });              
  },
  created: function(){     
    google.maps.event.addDomListener(window, 'load', this.initGmap);
  },
  methods:{
    initGmap (){                                  
      this.map.setZoom(this.mapOptions.zoom);
      this.map.setCenter(this.mapOptions.center);

      let vm = this
      //--------- mark mtl ------------------- 
      var tpMtlMarker = new google.maps.Marker({position: vm.MTL.lnglat, map: this.map, title: vm.MTL.title});
      google.maps.event.addListener(tpMtlMarker, 'click', function() { vm.moveToLocation(vm.MTL.lnglat, vm.MTL.title) });
        
      //--------- mark TOR -------------------   
      var tpTorMarker = new google.maps.Marker({position: vm.TOR.lnglat, map: this.map, title: vm.TOR.title});
      google.maps.event.addListener(tpTorMarker, 'click', function() { vm.moveToLocation(vm.TOR.lnglat, vm.TOR.title);}); 

      //--------- mark brock -------------------   
      var tpBrockMarker = new google.maps.Marker({position: vm.BROCK.lnglat, map: this.map, title: vm.BROCK.title});
      google.maps.event.addListener(tpBrockMarker, 'click', function() { vm.moveToLocation(vm.BROCK.lnglat, vm.BROCK.title);}); 

      //Associate the styled map with the MapTypeId and set it to display.
      this.map.mapTypes.set('map_style', this.styledMap);
      this.map.setMapTypeId('map_style');      
    },
    sendmessage() {
        
        this.$v.Contact.$touch();
        // if its still pending or an error is returned do not submit
        if (this.$v.Contact.Email.$error || this.$v.data.Message.$error || this.$v.data.DIVISION.$error) {        
          return;
        }
        
        axios.post('https://api.transplus.com/sendmail/', {data: this.data, contact: this.Contact} )
        .then((response) => {
          //alert(JSON.stringify(this.Contact))          
          alert("Message Sent")
          window.scrollTo(0, 0);
          this.$router.go('/');          
        })
        .catch(e => {
          alert(e)
          console.log(e)
        })
         
    },
    moveToLocation(latLng,name){   
      this.map.setZoom(15);
      this.map.setCenter(latLng);
      var tpMarker = new google.maps.Marker({position: latLng, map: this.map, title: name});           
    }
  }
};
</script>

<style scoped>
::placeholder {
  color: rgb(205, 205, 205);
}
label {
  margin-top:15px;
}

.custom_form {
  
  border:1px solid #333;
  width: 100%;
  padding: 12px 20px;
  margin-bottom: 8px;
  box-sizing: border-box;
}

.custom_form:focus {
  outline: none !important;
  border:1px solid #55B550;
  box-shadow: 0 0 4px #55B550;
}

.error {
  border:1px solid #800020;
  box-shadow: 0 0 4px #800020 ;
}


.hoverblue {
  color: #999;
  background-color: rgb(245, 245, 245);
  border-width: 0;
  font-weight: bold;
  font-size: 12px;    
  margin: 20px 1px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.hoverblue:hover{
  color: white;
  background-color: dodgerblue;
}

.negative-section{
  
  /*
    width:100%;
    margin-left: auto;
    margin-right: auto;
    margin-top: -100px;
    height:400px;    
    z-index:99;
  */    
}
.turngreen {
  transition: 0.3s;
  margin:10px;
}
.turngreen:hover {
   background-color:#55B550; 
   color:white; 
   border-radius: 5px;
   margin-bottom:10px;
}

@media only screen and (max-width: 600px) {  
  .negative-section{
      text-align:center;
  }
}

</style>
